import { render, staticRenderFns } from "./PreviewComponent.vue?vue&type=template&id=98c3fc06&scoped=true&"
import script from "./PreviewComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreviewComponent.vue?vue&type=style&index=0&id=98c3fc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c3fc06",
  null
  
)

export default component.exports